<script setup lang="ts">
import { ref, inject, onMounted } from "vue";
import { TranslationService } from "../services/translation.service";
import { SITEURL } from "@libTs/cms.globals";
import { IItem } from "../interfaces/cart.interfaces";
import axios from "axios";
import { CartService } from "../services/cart.service";

interface IThpSetRequest {
    value: string;
}

interface IThpSaveResponse {
    saved: boolean;
    status: number;
}
interface IThpGetResponse {
    value: string;
    status: number;
}

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const cartSvc = inject<CartService>("cartSvc") as CartService;

const { title, lead, buttonText } = defineProps({
    title: {
        type: String,
        default: "Free text order",
    },
    lead: {
        type: String,
        default:
            "Please mention product description, catalog- and CAS number, brand, pack size and order quanity.",
    },
    buttonText: {
        type: String,
        default: "Save and add to cart",
    },
});

const THP_ITEMCODE = "thp";
const THP_ITEMNAME = "Third-party";

const thpValue = ref("");
const isThpLoading = ref(false);
const thpSaveSuccessful = ref(false);
const ResponseStatus = ref(0);

onMounted(() => {
    initializeEventlisteners();
});

const addThpToCart = (displayOverlay?: boolean) => {
    if (!isThpLoading.value) {
        thpSaveSuccessful.value = false;
        isThpLoading.value = true;

        const saveThpRequest: IThpSetRequest = {
            value: thpValue.value,
        };

        axios
            .post<IThpSaveResponse>(
                SITEURL + "actions/sapShop/thp/set-value",
                saveThpRequest,
                {
                    responseType: "json",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                },
            )
            .then(
                // success
                (response) => {
                    const data = response.data;

                    if (typeof data !== "undefined" && data) {
                        ResponseStatus.value = data.status;

                        if (data.saved && data.status === 200) {
                            const thpItem: IItem = {
                                ItemCode: THP_ITEMCODE,
                                ItemName: THP_ITEMNAME,
                                ItmsGrpCod: "",
                                ItmsGrpNam: "THP",
                                CAS: "",
                                Brand: "",
                                BrandName: "",
                                MSDS: undefined,
                                Packsize: "",
                                Availability: "0",
                                LeadTime: 0,

                                Preis: 0,
                                Curr: "CHF",
                                SpecialPrice: true,

                                quantity: 1,
                                qty: 1,
                                PriceTyp: 0,
                            };

                            cartSvc.thpAddToCart(
                                thpItem,
                                thpItem.qty,
                                displayOverlay,
                            );

                            thpSaveSuccessful.value = true;

                            // console.log("THP successfully saved.");
                        } else if (data.status === 404) {
                            console.warn(
                                "THP not saved, login session has expired.",
                            );
                        } else if (data.status === 500) {
                            console.warn(
                                "THP not saved: There was an error in the service.",
                            );
                        }
                    } else {
                        console.warn(
                            "THP not saved: There was an error in the service.",
                        );
                        // console.log(response);
                    }
                },

                // error
                (response: any) => {
                    console.warn("Error: No response from server.");
                    // console.log(response);
                },
            )
            .finally(() => {
                isThpLoading.value = false;
            });
    }
};

const initializeEventlisteners = () => {
    document.addEventListener("updateThpInCartStatus", (e: any) => {
        const isThpInCart = e.detail.isThpInCart;
        if (isThpInCart === false) {
            // remove THP from DB
            axios
                .post(
                    SITEURL + "actions/sapShop/thp/set-value",
                    {
                        value: "",
                    } as IThpSetRequest,
                    {
                        responseType: "json",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest",
                        },
                    },
                )
                .then(
                    // success
                    () => undefined,
                    // error
                    (err) => console.error(err),
                );
        }
        // isThpInCart.value = isThpInCart;
    });

    document.addEventListener("thpLoading", (e: any) => {
        isThpLoading.value = true;
    });

    document.addEventListener("thpValueUpdate", (e: any) => {
        const append = e.detail.append;
        const addToCart = e.detail.addToCart;
        const thpStr = e.detail.value;

        if (append === true) {
            thpValue.value +=
                (thpValue.value.length > 0 ? "\n\n" : "") + thpStr;
        } else {
            thpValue.value = thpStr;
        }

        if (addToCart === true) {
            addThpToCart(false);
        }
    });

    document.addEventListener("thpLoaded", (e: any) => {
        isThpLoading.value = false;
    });
};
</script>

<template>
    <div class="row">
        <div
            class="col-sm-offset-2 col-sm-8 col-lg-offset-3 col-lg-6"
            @click="$event.stopPropagation()"
        >
            <h2 class="mb-10">{{ title }}</h2>
            <p class="mb-10">{{ lead }}</p>
            <textarea
                class="w-full h-60 p-5 rounded bg-grey-50"
                :class="{ disabled: isThpLoading }"
                name="thpValue"
                v-model="thpValue"
                :disabled="isThpLoading"
            ></textarea>
            <p class="mt-8">
                <a
                    class="btn-cb"
                    :class="{
                        disabled: isThpLoading,
                        'loading-animation': isThpLoading,
                    }"
                    @click="addThpToCart(true)"
                    >{{ buttonText }}</a
                >
            </p>
        </div>
    </div>
</template>
